export default __webpack_public_path__ + "static/media/exclamationMarkFilled.b0997c81.svg";